enum CardIntegrations {
    Accomplish = 'ACCOMPLISH',
    GPS = 'GPS',
    Marqeta = 'MARQETA',
}
export default CardIntegrations